import { useTorneiDelGioco, type UseTorneiDelGioco } from '@/hooks/useTorneiDelGioco';
import { BACKGAMMON_GAME_ID } from '@/lib/gameFeatures';

/**
 * I tornei di backgammon della lobby: la lista pubblica Limulo, filtrata sul catalogo giochi.
 *
 * Il corpo e' `useTorneiDelGioco` (`hooks/useTorneiDelGioco.ts`), estratto per `profileType` in P2 degli scacchi su Limulo
 * (E6 di ADR-0193): qui resta il solo backgammon, con LO STESSO comportamento di prima — i cinque vuoti, `skip` come serratura
 * (con la sezione Limulo spenta niente chiamate), la lista chiesta GIA' filtrata dal server (`?gameId=`, I-342).
 */
export function useBackgammonTournaments({ skip = false }: { skip?: boolean } = {}): UseTorneiDelGioco {
  return useTorneiDelGioco({ gioco: BACKGAMMON_GAME_ID, skip });
}
